import { render, staticRenderFns } from "./SystemTagForm.vue?vue&type=template&id=2e1d5eac&scoped=true"
import script from "./SystemTagForm.vue?vue&type=script&lang=ts"
export * from "./SystemTagForm.vue?vue&type=script&lang=ts"
import style0 from "./SystemTagForm.vue?vue&type=style&index=0&id=2e1d5eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d5eac",
  null
  
)

export default component.exports